import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "../../../auth/auth.service";

@Component({
  selector: "app-access-denied",
  templateUrl: "./access-denied.component.html",
  styleUrls: ["./access-denied.component.scss"],
})
export class AccessDeniedComponent {
  constructor(private router: Router,
    private authService: AuthService
  ) { }

  gotoDashboard() {
    return this.router.navigate([this.authService.user.homePageUrl]);
  }
}
